import { CascoExpiryRow } from "./types";

export const transformCascoExpiryRow = (res: any): CascoExpiryRow => {
  return {
    id: res.id,
    vehicle: res.vehicle,
    registrationPlate: res.registrationPlate,
    expiryDate: res.expiryDate,
  };
};
